import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI, { Loading } from 'element-ui'
import {Icon} from '@iconify/vue2'
import 'element-ui/lib/theme-chalk/display.css';
import "element-ui/lib/theme-chalk/index.css";
import 'vant/lib/index.css';
import 'vant/lib/index.less';
import '@/assets/theme/index.css'
import "@/assets/global.css";
import "@/assets/iconfont/iconfont.css"
import '@/assets/iconfont/iconfont.js'
import '@/assets/scss/themes.scss'
import '@/assets/scss/reset.scss'
import '@/assets/scss/iconfont/iconfont.css'
import dayjs from 'dayjs'
import axios from '@/utils/request'
import apis from '@/apis'
import { ButtonShow } from '@/utils/auth'
import GlobalPagination from '@/components/pagination/GlobalPagination.vue'
import CustomUpload from '@/components/CustomUpload'
import Ellipsis from '@/components/common/Ellipsis'
import WDialog from '@/components/common/WDialog'
import Tip from '@/components/common/Tip'
import Avatar from '@/components/common/Avatar'
import Icon2 from '@/components/Icon'
import qs from 'qs'
import CustomMapMarker from '@/components/CustomMapMarker'
import CustomEditor from './components/CustomEditor.vue'
import CustomExport from './components/CustomExport.vue'
import config from '@/utils/config'
// import VueAMap from "vue-amap";
import '@/utils/Injection'
// Vue.use(VueAMap)
Vue.use(Ellipsis);
Vue.use(WDialog);
Vue.use(Tip);
Vue.use(Avatar);
Vue.use(ElementUI)
//注册iconify图标库

Vue.prototype.$ELEMENT = { size: 'mini', zIndex: 3000 }
Vue.prototype.$loading = Loading.service
Vue.config.productionTip = false
Vue.prototype.$dayjs = dayjs
Vue.prototype.$axios = axios
Vue.prototype.$apis = apis
Vue.prototype.$ButtonShow = ButtonShow
Vue.prototype.$qs = qs
Vue.prototype.$config = config
Vue.component('CustomUpload', CustomUpload)
Vue.component('GlobalPagination', GlobalPagination)
Vue.component('iconify', Icon)
Vue.component('icon', Icon2)
Vue.component('CustomMapMarker', CustomMapMarker)
Vue.component('CustomEditor', CustomEditor)
Vue.component('CustomExport', CustomExport)

Vue.prototype.$event = new Vue()

/*高德地图组件初始化*/
// VueAMap.initAMapApiLoader({
//   key: '6215af0230f0e5246e0fd36095d8a45e',
//   uiVersion: '1.0',
//   plugin: [
//     'AMap.AutoComplete',
//     'AMap.ElasticMarker',
//     'AMap.PlaceSearch',
//     "AMap.MapType",
//     "AMap.Geocoder",
//     'AMap.Geolocation'
//   ],
//   v: '1.4.4'
// });

// 自定义权限指令
// Vue.directive('visible', {
//   bind (el, binding) {
//     if (!store.state.buttonList.some(item => binding.value === item.butCode)) {
//       el.style.display = 'none'
//     }
//   }
// })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
